// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.POBresUdLkrDaeT1VG9X{--collapse-container-border-color:transparent}.CJ2HIigKFB0kt9PGh89Q{background:var(--yellow-20);color:var(--yellow-100);border:1px solid var(--black-10);border-radius:4px;padding:2px 4px}a.bqwbNSNxY2MWRlabA7Il{font-size:13px;font-style:normal;font-weight:500;line-height:16px;text-decoration:underline}a.bqwbNSNxY2MWRlabA7Il:hover{color:var(--light-blue-70)}.dShC4VYAXk0rY0bhDbCR{padding-top:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"withoutBorder": `POBresUdLkrDaeT1VG9X`,
	"badge": `CJ2HIigKFB0kt9PGh89Q`,
	"link": `bqwbNSNxY2MWRlabA7Il`,
	"usersContent": `dShC4VYAXk0rY0bhDbCR`
};
export default ___CSS_LOADER_EXPORT___;
